var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card mb-2"},[_c('div',{staticClass:"card-header"},[_c('h3',[_vm._v(_vm._s(_vm.module))])]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('canvas',{attrs:{"id":_vm.module,"graphType":_vm.graphType}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }